/**
 * `Field`-related view with two states - a view state and an edit state. The view state only presents a UI for viewing the associated field value, whereas the edit state presents a UI for modifying the field value.
 *
 * ## Fields
 * Name | Description
 * field | The `Field` model associated with this view.
 * model | The model associated with this view. This model is sent to the `field` object to acquire the update the field value.
 *
 * ## Events
 * Name | Arguments | Description
 * change | The new field value | Fires whenever the field value changes.
 * @module app/views/InputView
 */
import Backbone from "backbone";
import _ from "underscore";
import fieldViewFactory from "core/views/Field/FieldViewFactory";
export default Backbone.View.extend({
  /**
   * Initializes the control.
   * @param  {object} options The options hash.
   * @param {Field} options.field The field to associate with this view.
   * @param {Backbone.Model|Object} options.model The model to associate with this view.
   */
  initialize: function (options) {
    this.options = options;

    var self = this;

    Object.defineProperty(this, "model", {
      get: function () {
        if (self._viewer) {
          //we have a viewer regardless of what mode we are
          return self._viewer.model;
        } else {
          return self.options.model;
        }
      },
    });
  },

  template: _.template(
    '<% if(field.isEditable(model) && mode != "view"){ %><span class="view"></span><span class="edit"></span><% } else { %><span class="all"></span><% } %>'
  ),

  /**
   * Propagate the field value from the model to this control.
   * @deprecated
   * @param  {Boolean} [silent] True to prevent a "change" event from firing, otherwise false.
   */
  refresh: function (silent) {},

  /**
   * Propagate the field value from this control to the underlying model.
   * @deprecated
   */
  updateValue: function () {},

  render: function () {
    var field = this.options.field;
    var model = this.options.model;
    var options = _.defaults(this.options);

    this.$el.html(this.template(options));

    if (field.isEditable(model) && this.options.mode != "view") {
      this._editor = fieldViewFactory.getEditor(
        this.options.field,
        this.options.model
      );
      this._viewer = fieldViewFactory.getViewer(
        this.options.field,
        this._editor.model
      );

      this._editor.render();
      this._editor.on(
        "change",
        function () {
          this.trigger("change", this._editor.value);
        },
        this
      );
      this.$(".edit").append(this._editor.$el);

      this._viewer.render();
      this.$(".view").append(this._viewer.$el);
    } else {
      this._viewer = fieldViewFactory.getViewer(
        this.options.field,
        this.options.model
      );
      this._viewer.render();
      this.$(".all").append(this._viewer.$el);
    }

    this.$(".edit").hide();
  },

  /**
   * Transitions the view to the "edit" state.
   */
  showEdit: function () {
    this.$(".edit").show();
    this.$(".view").hide();
  },

  /**
   * Transitions the view to the "view" state.
   */
  hideEdit: function () {
    this.$(".view").show();
    this.$(".edit").hide();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/InputView.js
// module id = 836
// module chunks = 1